import { render, staticRenderFns } from "./Funcionario.vue?vue&type=template&id=5a093a35&"
import script from "./Funcionario.vue?vue&type=script&lang=js&"
export * from "./Funcionario.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports